export default {
    //AcademyComponent
    customization: 'Personalitza la teva acadèmia',
    sections: 'Seccions de personalització',
    // Secciones del menú lateral: cada descripción nombra solo lo que hay en esa pantalla.
    identity: 'Identitat',
    identity_description: 'Nom, eslògan, logo i favicon',
    design: 'Disseny',
    design_description: 'Colors i tipografies',
    home: 'Portada',
    home_description: 'Capçalera, bàner i descripció',
    description_location_help: 'On es mostra: amb la capçalera «2 Columnes, Text + Imatge» apareix al costat de la imatge, a dalt de la portada. Amb les capçaleres de bàner a mida completa apareix a la secció de contacte, al final de la portada.',
    menu_section_description: 'Enllaços del menú del web',
    contact_social: 'Contacte i xarxes',
    contact_description: 'Contacte, xarxes i HTML propi',
    legal_description: 'Privacitat i avís legal',
    settings: 'Configuració',
    settings_description: 'Domini, idioma i scripts',
    domain: "Domini",
    brand_logo: "Logo i Marca",
    rrss_contact: "Contacte i RRSS",
    legal: "Legal",
    options: 'Opcions',

    //DomainComponent
    your_domain: "El teu domini mybrainspro.com",
    example_url_placeholder: 'https://',
    example_2: '.mybrainspro.com',
    info_domain: "Escriu el domini SENSE símbols (.--?!·$%&/()...), ni accents ni espais en blanc. No cal que posis www.",
    domain_input: "Domini mybrainspro.com",
    custom_domain: "Domini personalitzat",
    domain_text: 'Domini',
    info_domain2: "Introdueix el teu domini (www.tudominio.com) per utilitzar-lo com a pàgina principal o com a pàgina secundària (tuescuela.tudominio.com)",
    attention: "Atenció",
    info_attention: "Només disponible per a pla AVANÇAT i pla PRO",
    activate_domain: "Per activar el teu domini a BrainsPro: ",
    info_activate_1line: "Visita la plataforma on vas comprar el teu domini i cerca la configuració de DNS.",
    info_activate_2line: "Afegeix el registre de tipus A a la IP: 76.223.11.227",
    info_activate_3line: "Tingues en compte que poden passar 48 hores fins que aquests canvis es facin efectius i es propaguin al teu DNS. Un cop llest, ja pots començar a utilitzar la nova adreça de la teva acadèmia en línia a BrainsPro.",
    info_activate_4line: "L'equip de brainspro es posarà en contacte amb tu per enviar-te uns registres addicionals que hauràs de col·locar als teus DNS. Amb ells generarem la teva web segura (https://)",
    example_academy: 'acadèmia-d-exemple',
    example_domain: 'mevaacadèmia.com',
    //LanguageSelector
    lang: 'Idioma',
    academy_lang: 'Idioma de l\'Acadèmia',
    academy_lang_selector_text: 'Trieu l\'idioma de la vostra acadèmia',

    //BrandingComponent
    banner: 'Banner',
    brand_academy: "Marca de la teva acadèmia",
    academy_name: "Nom d'Acadèmia",
    full_name: "Trieu el nom complet de la vostra acadèmia",
    tagline: "Eslògan de l'acadèmia",
    slogan: "Trieu l'eslògan de la vostra acadèmia",
    tagline_placeholder: "Escriu aquí el teu eslògan",
    search: 'Cerca',
    my_academy: 'La meva Acadèmia a BrainsPro',
    change: 'Canviar',
    insert: 'Inserir',
    href_custom_academy: 'Més sobre personalitzar la teva acadèmia.',

    //ContactComponent
    description: "Descripció",
    web_rrss: "Web i Xarxes Socials",
    web_blog: "Web o Blog",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
    youtube: "Youtube",
    location: "Ubicació i dades fiscals",
    address_line_1: "Adreça, línia 1",
    address_line_2: "Adreça, línia 2",
    postalcode: "Codi postal",
    city: "Ciutat",
    province: "Província",
    country: "País",
    company_name: "Denominació Social",
    nif_cif: "NIF/CIF",

    //LegalComponent
    privacy_policy: "Política de Privadesa",
    text_register: "Text resum per a registre d'usuari",
    user_view_text: "Aquest text es mostrarà al registre d'usuari, com a resum de la versió més extensa que es mostrarà a la pàgina d'avís legal de la vostra acadèmia.",
    privacy_policy_page: "Pàgina de Política de Privadesa",
    privacy_policy_academy_page: "Pàgina de Política de Privadesa de l'acadèmia",
    legal_notice: "Avís Legal",
    href_legal: 'Més sobre Avís Legal i Política de Privadesa.',

    //Contact
    contact_bloq: 'Bloc de contacte',
    html_bloq: 'Insereix un bloc html per acompanyar la informació de contacte. Com un iframe de google maps.',

    //Branding
    //BannerBrandingComponent
    upload_banner: 'Puja el teu banner',
    image_format: 'PNG, JPG, GIF fins a 3MB',
    banner_size_recommendation: 'Recomanat: imatge panoràmica, d\'almenys 1600×600 px. En pantalles petites es mostrarà completa; en pantalles grans es retallarà per ocupar tota l\'amplada.',

    //ColorsComponent
    desing_colors: 'Disseny i Colors',
    header_type: 'Tipus de capçalera',
    banner_complete: 'Bàner a mida completa',
    banner_complete_no_text: 'Bàner a mida completa sense text',
    columns_text_image: '2 Columnes, Text + Imatge',
    banner_info: 'Amb això canviaràs el tipus d\'imatge de portada que veuran els usuaris a la teva acadèmia.',
    enterprise_color: 'Color corporatiu',
    text_color: 'Color de text',

    //FontsComponent
    desing_fonts: 'Tipografia',
    fonts_info: 'Tria la font que s\'usarà en cada tipus de text de la teva acadèmia.',
    font_h1: 'Títol principal (H1)',
    font_h2: 'Subtítol (H2)',
    font_h3: 'Títol de secció (H3)',
    font_body: 'Text normal',
    font_default: 'Per defecte',

    //FaviconComponent
    favicon: 'Favicon',
    favicon_help: 'Icona que apareix a la pestanya del navegador.',
    upload_favicon: 'Puja el teu favicon',
    favicon_format: 'PNG, JPG, GIF fins a 3MB',

    //LogoBrandingComponent
    logo: 'Logo',
    logo_help: 'Apareix a la capçalera del web i als certificats.',
    upload_logo: 'Puja el teu logo',

    //OptionsComponent
    register_config: 'Configuració de Registre',
    info_button_register: "En activar aquest botó es desactivarà l'opció de registrar-vos a l'acadèmia. Per això tots els usuaris hauran de registrar-se des de l'App de Brainspro.",
    restricted_register: 'Restricció de registre',

    //MenuComponent
    menu: 'Menú',
    menu_description: "Tria quins enllaços apareixen al menú superior del web de la teva acadèmia i en quin ordre.",
    menu_default_notice: "Encara no has afegit cap element, així que el teu web fa servir el menú per defecte. Quan n'afegeixis un, el menú mostrarà només els elements d'aquesta llista.",
    add_menu_item: 'Afegeix un element',
    edit_menu_item: "Edita l'element",
    menu_item_edit: 'Edita',
    menu_item_type: 'Tipus',
    menu_item_type_catalog: 'Catàleg',
    menu_item_type_contact: 'Contacte',
    menu_item_type_page: 'Pàgina',
    menu_item_type_link: 'Enllaç',
    menu_item_type_home: 'Inici',
    menu_item_type_home_help: 'Porta a la pàgina principal de la teva acadèmia.',
    menu_item_type_catalog_help: 'Porta a la pàgina amb tots els teus cursos.',
    menu_item_type_contact_help: "Porta a la secció de contacte de la teva pàgina d'inici.",
    menu_item_type_link_help: 'Porta a qualsevol adreça web que escriguis.',
    menu_item_title: "Text de l'enllaç",
    menu_item_add_translations: 'Afegeix el nom en altres idiomes',
    menu_item_hide_translations: 'Amaga els noms en altres idiomes',
    menu_item_translations: 'Nom en altres idiomes',
    menu_item_translations_example: "Exemple: si l'enllaç es diu \"Cursos\", en anglès pots escriure \"Courses\".",
    menu_item_page: 'Pàgina',
    menu_item_select_page: 'Tria una pàgina',
    menu_item_page_invalid: "La pàgina d'aquest element ja no està disponible. Tria'n una altra per poder desar.",
    menu_pages_loading: 'Carregant pàgines…',
    menu_pages_error: "No s'han pogut carregar les pàgines de l'acadèmia.",
    menu_no_pages: "Encara no tens pàgines. Escriu-nos a suport i t'ajudarem a crear-les.",
    menu_page_unavailable: 'Pàgina no disponible',
    menu_page_unavailable_help: "La pàgina d'aquest element ja no existeix, així que no es mostra al web. Edita'l per triar-ne una altra.",
    menu_item_url: 'URL',
    menu_item_url_help: 'Ha de començar per https:// o http://.',
    menu_item_visible: 'Visible al web',
    menu_item_hidden: 'Ocult',
    move_menu_item_up: "Puja l'element",
    move_menu_item_down: "Baixa l'element",
    drag_menu_item: 'Arrossega per reordenar',
    delete_menu_item: "Elimina l'element del menú",
    delete_menu_item_confirm: "S'eliminarà «{title}» del menú. Aquesta acció no es pot desfer.",
    menu_item_saved: "L'element del menú s'ha desat",
    menu_item_deleted: "L'element s'ha eliminat del menú",
    menu_order_saved: "S'ha desat l'ordre del menú",
    menu_order_error: "No s'ha pogut desar l'ordre del menú. S'ha restaurat l'ordre anterior.",
    menu_unexpected_error: "S'ha produït un error inesperat amb el menú",
    menu_item_name_es: 'Nom en castellà',
    menu_item_name_en: 'Nom en anglès',
    menu_item_name_ca: 'Nom en català',
    menu_item_name_de: 'Nom en alemany',
    menu_item_name_pt: 'Nom en portuguès',

}